import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-navigator-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <!-- Top fixed progress bar shown during route navigation -->
    <div
      *ngIf="visible"
      class="fixed top-0 left-0 right-0 z-50"
      role="progressbar"
      aria-label="Chargement de la navigation"
    >
      <div class="h-1 w-full bg-gray-200 overflow-hidden">
        <!-- Animated gradient bar -->
        <div class="h-full w-1/3 bg-gradient-to-r from-primary-400 via-primary-600 to-primary-400 animate-[loaderMove_1.2s_ease-in-out_infinite]"></div>
      </div>
    </div>
  `,
  styles: [`
    /* Smooth looping translation for the gradient segment */
    @keyframes loaderMove {
      0% { transform: translateX(-100%); }
      50% { transform: translateX(50%); }
      100% { transform: translateX(200%); }
    }
  `]
})
export class NavigatorLoaderComponent {
  // Whether the loader is visible
  @Input() visible = false
}


